import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "backoffice-trainer-list"
}
const _hoisted_2 = { class: "text-capitalize" }
const _hoisted_3 = { class: "d-flex pt-4 pb-4 align-items-center" }
const _hoisted_4 = { class: "fs-5" }
const _hoisted_5 = { class: "ms-auto" }
const _hoisted_6 = { class: "row d-flex" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "flex-shrink-0" }
const _hoisted_9 = { class: "avatar avatar-circle" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "avatar-img",
  src: "https://htmlstream.com/preview/front-v4.3.1/assets/img/160x160/img1.jpg"
}
const _hoisted_12 = { class: "flex-grow-1 ms-3 mb-0" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "text-capitalize" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  style: {"padding":"0.5rem"},
  class: "ms-2 badge bg-soft-primary text-primary"
}
const _hoisted_19 = { class: "justify-content-end d-flex" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-people-fill" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1)
const _hoisted_23 = { class: "pt-4 pb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreateTrainerModal = _resolveComponent("CreateTrainerModal")!
  const _component_ManageAccountModal = _resolveComponent("ManageAccountModal")!
  const _component_DeleteEntityModal = _resolveComponent("DeleteEntityModal")!
  const _component_MrUiKitButton = _resolveComponent("MrUiKitButton")!
  const _component_MrUiKitTable = _resolveComponent("MrUiKitTable")!
  const _component_MrUiKitPagination = _resolveComponent("MrUiKitPagination")!
  const _component_MrUiKitCard = _resolveComponent("MrUiKitCard")!

  return (_ctx.entityId !== -1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showAddModal === true)
          ? (_openBlock(), _createBlock(_component_CreateTrainerModal, {
              key: 0,
              modelValue: _ctx.newTrainer,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newTrainer) = $event)),
              entity: _ctx.entity,
              onSubmit: _ctx.onCreate,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddModal = false))
            }, null, 8, ["modelValue", "entity", "onSubmit"]))
          : _createCommentVNode("", true),
        (_ctx.showAccountModal === true && _ctx.selectedTrainer)
          ? (_openBlock(), _createBlock(_component_ManageAccountModal, {
              key: 1,
              entity: _ctx.trainerEntity,
              id: _ctx.selectedTrainer.id,
              onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAccountModal = false))
            }, null, 8, ["entity", "id"]))
          : _createCommentVNode("", true),
        (_ctx.showDeleteModal === true && _ctx.selectedTrainer)
          ? (_openBlock(), _createBlock(_component_DeleteEntityModal, {
              key: 2,
              name: _ctx.selectedTrainer.firstname + ' ' + _ctx.selectedTrainer.lastname,
              onSubmit: _ctx.onSubmitDelete,
              onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDeleteModal = false))
            }, null, 8, ["name", "onSubmit"]))
          : _createCommentVNode("", true),
        _createVNode(_component_MrUiKitCard, {
          headerClasses: ['border-bottom'],
          bodyClasses: ['pt-0', 'pb-0']
        }, {
          header: _withCtx(() => [
            _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.t("common.trainers")), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.t("backoffice.sideNavTabs.subtitles.trainers")) + " " + _toDisplayString(_ctx.t("common." + _ctx.entity)), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_MrUiKitButton, { onClick: _ctx.onOpenAdd }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("common.operations.add")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_MrUiKitTable, {
                rows: _ctx.trainers,
                columns: _ctx.columns,
                search: true,
                searchLabel: _ctx.searchLabel,
                onSearch: _ctx.onSearch
              }, {
                fullname: _withCtx(({ item }) => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        (item.photo)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "avatar-img",
                              src: item.photo.url
                            }, null, 8, _hoisted_10))
                          : (_openBlock(), _createElementBlock("img", _hoisted_11))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("h5", {
                        class: "mb-0 link-navigate",
                        onClick: () => _ctx.onNavigate(item)
                      }, _toDisplayString(item.firstname) + " " + _toDisplayString(item.middlename) + " " + _toDisplayString(item.lastname), 9, _hoisted_13)
                    ])
                  ])
                ]),
                organizations: _withCtx(({ item }) => [
                  _createElementVNode("span", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.organizations, (org, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        onClick: _withModifiers(($event: any) => (_ctx.goToOrganization(org)), ["prevent"]),
                        key: 'trainer-org-' + org.id,
                        class: "pointer-sub link-secondary"
                      }, [
                        (index < 3)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(org.fullname), 1))
                          : _createCommentVNode("", true),
                        (index < 2 && index < item.countOrganizations - 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, ","))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_15))
                    }), 128))
                  ]),
                  (item.countOrganizations > 3)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, " + " + _toDisplayString(item.countOrganizations - 3), 1))
                    : _createCommentVNode("", true)
                ]),
                action: _withCtx(({ item }) => [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_MrUiKitButton, {
                      classes: ['btn-icon btn-primary-outline btn-sm'],
                      onClick: ($event: any) => (_ctx.onOpenAccount(item))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_MrUiKitButton, {
                      classes: ['btn-icon btn-primary-outline btn-sm'],
                      onClick: ($event: any) => (_ctx.onNavigate(item))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_MrUiKitButton, {
                      classes: ['btn-icon btn-primary-outline btn-sm'],
                      onClick: ($event: any) => (_ctx.onDelete(item))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_22
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["rows", "columns", "searchLabel", "onSearch"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_MrUiKitPagination, {
                modelValue: _ctx.pagination,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pagination) = $event)),
                onLoad: _ctx.loadMore
              }, {
                default: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.t("pagination.page")) + " " + _toDisplayString(_ctx.pagination.current) + " " + _toDisplayString(_ctx.t("pagination.of")) + " " + _toDisplayString(slotProps.lastPage), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "onLoad"])
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}